import styled from "styled-components";

export const StyledFooter = styled.div`
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  gap: 8px;
  padding: 15px;
  padding-bottom: 5px;
  background-color: ${({ theme }) => theme.colors.shadyLady};
  color: ${({ theme }) => theme.colors.greyNickel};
  font-size: 14px;
  justify-content: center;
  grid-column: span 2;
  max-height: 150px;
  align-self: end;

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    grid-column: 1;
    grid-template-rows: auto;
    max-height: 450px;
  }
`;

export const ContactSection = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  justify-content: center;

  div {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.mobileMax}) {
    align-items: center;
    grid-template-columns: 1fr;
  }
`;

export const EmergencyNumber = styled.div`
  font-weight: 700;
  margin-left: 20px;
  
  @media (max-width: ${({ theme }) => theme.breakPoints.mobileMax}) {
    margin-left: 0px;
  }
`;

export const Icon = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.primary};
`;

export const ServiceRules = styled.div`
  text-align: center;

  a {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.intensivePink};

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover div {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.1s ease-in-out;
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  bottom: 120%;
  left: 50%;
  transform: translateX(-51%);
  background-color: #333;
  color: white;
  padding: 5px;
  border-radius: 5px;
  font-size: 12px;
  white-space: nowrap;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.1s ease-in-out, visibility 0s 0.1s;
  z-index: 100;
  line-height: 1.5;

  &:before {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
  }
`;
